export const SOCIAL_TYPE_WITHOUT_PAGE = ['TWITTER', 'INSTAGRAM', 'GOOGLE'];
